<swiper-container>
  @for (slide of slidersData(); track $index) {
    <swiper-slide>
      <ion-grid class="ion-padding-bottom">
        <ion-row class="ion-padding-bottom">
          <ion-col>
            <div
              class="text-grey ion-padding-top ion-text-uppercase font-size-12"
              [innerHTML]="slide.header | translate"
            ></div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="ion-padding-bottom">
            <div>
              <ion-icon
                name="{{ slide.icon }}"
                class="icon-x4 text-dark bg-primary ion-padding"
              >
              </ion-icon>
            </div>
            <div class="ion-padding-top pb-05 text-bold">
              <ion-text color="primary">{{ slide.title | translate }}</ion-text>
            </div>
            <div class="ion-padding-bottom text-grey-600">
              <small>{{ slide.message | translate }}</small>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </swiper-slide>
  }
</swiper-container>
